import attendanceStudentsReport from './components/attendanceStudentsReport.vue';


export default {
  routes: [
    {
      path: '/',
      component:attendanceStudentsReport,
      name:'attendanceStudentsReport'
    },

  ]
};
